/* eslint-disable complexity */
import React, { useState, useEffect } from "react";
import { Tabs as AntTabs, Col, Row } from "antd";
import { ListItemData } from "@jd/focus-desktop-comps/lib/es/ListItem";
import { SearchGlobalParams, SearchGlobalRes, SearchType } from "@/services/SearchService";
import "./SearchJoyItem.less";

import { useTranslation } from "react-i18next";
import { SearchGlobalContext } from "@/components/Modals/SearchGlobalModal/utils";
import TabPaneAll from "@/components/Modals/SearchGlobalModal/panels/TabPaneAll";
import TabPaneQunzu from "@/components/Modals/SearchGlobalModal/panels/TabPaneQunzu";
import TabPaneJoySpace from "@/components/Modals/SearchGlobalModal/panels/TabPaneJoySpace";
import TabPaneYingyong from "@/components/Modals/SearchGlobalModal/panels/TabPaneApps";
import TabPaneLianxiren from "@/components/Modals/SearchGlobalModal/panels/TabPaneLianxiren";
import TabPaneTask from "@/components/Modals/SearchGlobalModal/panels/TaskPane/TabPaneTask";
import TabPaneSub from "@/components/Modals/SearchGlobalModal/panels/TaskPane/TabPaneSub";
import { analysisLog } from "@/utils/logAnalytics";
import TabPaneSchedule from "./panels/TabPaneSchedule";
import TabPaneDepartment from "./panels/TabPaneDepartment";
import SeacrchMassageHistoryList from "./SearchMessageHistoryList";
import { duccConfigI18 } from "@/utils/i18n";
import IconFont from "@/components/icon";
import ConditionSearch from "./ConditionSearch";
import ScrollView from "@/baseComponents/ScrollView";
import ConditionSearchHistoryMsg from "./ConditionSearchHistoryMsg/ConditionSearchHistoryMsg";

export type getAvatarURLFn = (url: string, width: number, height: number) => string;

export type SearchGlobalFn = (params: SearchGlobalParams) => Promise<SearchGlobalRes>;

const { TabPane } = AntTabs;

export interface TabData {
  key: SearchType;
}

const tabsData: TabData[] = [
  { key: SearchType.All },
  { key: SearchType.Contacts },
  { key: SearchType.Department },
  { key: SearchType.Group },
  { key: SearchType.Schedule },
  { key: SearchType.JoySpace },
  { key: SearchType.App },
  { key: SearchType.Task },
  { key: SearchType.MessageHistory }
];

export type ListItemClickFn = (
  type: SearchType,
  data: ListItemData & { pageSortNo: number; pageSize: number }
) => void;

// eslint-disable-next-line
function getTabPane(
  item: TabData,
  t: any,
  onClick?: ListItemClickFn,
  keyword = "",
  activeKey = "",
  setSearchGlobalValue?: (value: string) => void,
  setSelectorSwitch?: Function
) {
  switch (item.key) {
    case SearchType.All:
      return <TabPaneAll t={t} onClick={onClick} setSearchGlobalValue={setSearchGlobalValue} />;
    case SearchType.Contacts:
      return <TabPaneLianxiren t={t} onClick={onClick} />;
    case SearchType.Department:
      return <TabPaneDepartment t={t} onClick={onClick} />;
    case SearchType.Group:
      return <TabPaneQunzu t={t} onClick={onClick} />;
    case SearchType.JoySpace:
      return <TabPaneJoySpace onClick={onClick} />;
    case SearchType.Schedule:
      return <TabPaneSchedule onClick={onClick} />;
    case SearchType.App:
      return <TabPaneYingyong onClick={onClick} />;
    case SearchType.MessageHistory:
      return (
        <SeacrchMassageHistoryList
          t={t}
          activeKey={activeKey}
          keyWord={keyword}
          setSelectorSwitch={setSelectorSwitch}
        />
      );
    case SearchType.Task:
      return <TabPaneTask onClick={onClick} />;
    case SearchType.Sub:
      return <TabPaneSub />;
    default:
      return null;
  }
}

export default function Tabs({
  config,
  activeKey,
  onActiveKeyChange,
  onItemClick,
  onGetAvatarURL,
  onSearchGlobal,
  keyword,
  authData,
  isChange,
  setSearchGlobalValue
}: {
  config?: TabData[];
  onGetAvatarURL?: getAvatarURLFn;
  activeKey: SearchType;
  onActiveKeyChange: (activeKey: SearchType) => void;
  onItemClick?: ListItemClickFn;
  onSearchGlobal: SearchGlobalFn;
  keyword: string;
  authData?: any;
  isChange?: boolean;
  setSearchGlobalValue?: (value: string) => void;
}) {
  const { t } = useTranslation("common");
  const { t: t1 } = useTranslation("project");
  const [visible, setVisible] = useState(false);
  const [folderId, setFolderIds] = useState([]);
  const [joyTypeList, setJoyTypeList] = useState<any>([]);
  const [taskStatus, setTaskStatus] = React.useState<any>([]);
  const [scheduleDeadlineTime, setScheduleDeadlineTime] = React.useState<any>("");
  const [taskDeadlineTime, setTaskDeadlineTime] = React.useState<any>("");
  const [fileTypeList, setFileTypeList] = useState<any>([]);
  const [taskPriorityType, setTaskPriorityType] = React.useState<any>([]);
  const [scheduleColor, setScheduleColor] = React.useState<any>([]);
  const [searchValue, setSearchValue] = useState("");
  const [sessionType, setSessionType] = useState("");
  const [conditionHighlight, setConditionHighlight] = React.useState(false);
  const [msgType, setMsgType] = useState("");
  const [showSelector, setShowSelector] = useState(false);
  const [selectorSwitch, setSelectorSwitch] = useState(true);
  const [senderList, setSenderList] = useState<any[]>([]);
  const [msgTime, setMsgTime] = useState<any[]>(["", ""]);

  const [type, setType] = useState([]);

  let data = config;
  if (!data) {
    data = tabsData;
  }

  const onClose = () => {
    setVisible(false);
  };

  useEffect(() => {
    const isHighlight =
      (activeKey === SearchType.JoySpace && (type?.length || folderId?.length)) ||
      (activeKey === SearchType.Task &&
        (taskStatus?.length || taskDeadlineTime || taskPriorityType?.length)) ||
      (activeKey === SearchType.Schedule && (scheduleColor?.length || scheduleDeadlineTime));
    setConditionHighlight(!!isHighlight);
  }, [
    activeKey,
    type,
    folderId,
    taskStatus,
    taskDeadlineTime,
    taskPriorityType,
    scheduleColor,
    scheduleDeadlineTime
  ]);

  const onClose_msg = () => {
    setShowSelector(false);
  };

  const resultFilter = [
    SearchType.JoySpace,
    SearchType.MessageHistory,
    SearchType.Schedule,
    SearchType.Task
  ];

  return (
    <SearchGlobalContext.Provider
      value={{
        t,
        onGetAvatarURL,
        onSearchGlobal,
        keyword,
        activeKey,
        setTabIndex: onActiveKeyChange,
        authData,
        isChange,
        folderIds: folderId,
        types: type,
        joyTypeList: joyTypeList,
        taskStatus: taskStatus,
        taskDeadlineTime: taskDeadlineTime,
        scheduleDeadlineTime: scheduleDeadlineTime,
        fileTypeList: fileTypeList,
        taskPriorityType: taskPriorityType,
        scheduleColor: scheduleColor,
        searchValue: searchValue,
        sessionType: sessionType,
        msgType: msgType,
        senderList: senderList,
        msgTime: msgTime
      }}
    >
      <AntTabs
        size="small"
        className={resultFilter.includes(activeKey) ? "resFilterTabs" : "searchModalTabs"}
        style={{
          flex: 1
        }}
        activeKey={activeKey}
        onChange={(key) => {
          let logType = "";
          switch (key) {
            case "1":
              logType = "1";
              break;
            case "2":
              logType = "2";
              break;
            case "3":
              logType = "3";
              break;
            case "4":
              logType = "4";
              break;
            case "5":
              logType = "5";
              break;
            case "6":
              logType = "6";
              break;
            case "7":
              logType = "7";
              break;
            case "-1":
              logType = "8";
              break;
            case "9":
              logType = "9";
              break;
          }
          logType && analysisLog("xtbg_home_search_1641454991771", logType);
          if (visible) {
            onClose();
          }
          if (showSelector) {
            onClose_msg();
          }
          onActiveKeyChange(key as SearchType);
        }}
      >
        {data.map((item) => (
          <TabPane
            key={item.key}
            tab={t(`search.tabs.${item.key}`, {
              joyspace: duccConfigI18.joyspace
            })}
          >
            {item.key === SearchType.JoySpace ||
            item.key === SearchType.Schedule ||
            item.key === SearchType.Task ? (
              <>
                <Row>
                  <Col flex="auto">
                    <ScrollView nohorizontal="true">
                      {getTabPane(item, t, onItemClick, keyword, activeKey, setSearchGlobalValue)}
                    </ScrollView>
                  </Col>
                  {visible && (
                    <Col>
                      <ConditionSearch
                        setFolderIds={setFolderIds}
                        setType={setType}
                        setJoyTypeList={setJoyTypeList}
                        setTaskDeadlineTime={setTaskDeadlineTime}
                        setScheduleDeadlineTime={setScheduleDeadlineTime}
                        setTaskStatus={setTaskStatus}
                        setFileTypeList={setFileTypeList}
                        setTaskPriorityType={setTaskPriorityType}
                        setScheduleColor={setScheduleColor}
                        setSearchValue={setSearchValue}
                        t={t}
                        searchType={activeKey}
                        handleClose={onClose}
                        ConditionVisible={visible}
                      />
                    </Col>
                  )}
                </Row>
                {!visible && (
                  <div
                    className={`searchModalTabs_condition ${
                      conditionHighlight ? "searchModalTabs_Highlight" : ""
                    }`}
                    onClick={() => {
                      analysisLog("xtbg_joyspace_search_btn_screen", "70");
                      setVisible(true);
                    }}
                  >
                    <IconFont type="iconpc_ic_tjshaixuan_search" style={{ marginRight: 3 }} />
                    {conditionHighlight
                      ? t("Condition.conditional filtered")
                      : t("Condition.conditional filtering")}
                  </div>
                )}
              </>
            ) : item.key === SearchType.MessageHistory ? (
              <>
                <Row>
                  <Col flex="auto">
                    <ScrollView nohorizontal="true">
                      {getTabPane(
                        item,
                        t,
                        onItemClick,
                        keyword,
                        activeKey,
                        setSearchGlobalValue,
                        setSelectorSwitch
                      )}
                    </ScrollView>
                  </Col>
                  <Col className={showSelector && selectorSwitch ? "" : "col-no"}>
                    <ConditionSearchHistoryMsg
                      setMsgType={setMsgType}
                      setSessionType={setSessionType}
                      onClose={onClose_msg}
                      setSenderList={setSenderList}
                      setMsgTime={setMsgTime}
                    />
                  </Col>
                </Row>
                {activeKey === SearchType.MessageHistory && !showSelector && selectorSwitch && (
                  <div
                    className={`searchModalTabs_condition ${
                      sessionType || msgType || senderList?.length !== 0 || msgTime[0] || msgTime[1]
                        ? "searchModalTabs_Highlight"
                        : ""
                    }`}
                    onClick={() => {
                      setShowSelector(true);
                    }}
                  >
                    <IconFont type="iconpc_ic_tjshaixuan_search" style={{ marginRight: 3 }} />
                    {sessionType || msgType || senderList?.length !== 0 || msgTime[0] || msgTime[1]
                      ? t("Condition.conditional filtered")
                      : t("Condition.conditional filtering")}
                  </div>
                )}
              </>
            ) : (
              getTabPane(item, t, onItemClick, keyword, activeKey, setSearchGlobalValue)
            )}
          </TabPane>
        ))}
      </AntTabs>
    </SearchGlobalContext.Provider>
  );
}
